function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.96 69.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.7.52C3.77.82,2.62,1.55,1.45,3.8c-1.9,3.68-1.94,12.9-.06,15.59.99,1.42,1.76,7.53,2.51,19.97,1.65,27.37,2.17,30.43,5.18,30.43,3.27,0,5.07-6.15,6.16-21,.54-7.43.95-15.3.9-17.5s.57-5.7,1.37-7.77c1.81-4.69,2-20.79.26-22.53-1.17-1.17-3.43-1.27-11.06-.47",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.34,11.88c-.15,12.15-1.1,14.12-6.66,13.71-3.82-.28-4.2-.57-4.83-3.65-.37-1.84-1.18-3.84-1.79-4.45-1.62-1.62-1.35-9.91.41-12.43,1.04-1.49,2.84-2.29,5.75-2.56,7.61-.7,7.24-1.18,7.12,9.37",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.34,42.03c-1.5,30.32-5.95,32.62-6.31,3.26-.07-5.5-.52-11.69-.99-13.75l-.87-3.75h8.88l-.71,14.24",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/41.e5181e01ddf83589379892eec0224399.svg";
export { ForwardRef as ReactComponent };